module.exports = __webpack_public_path__ + "static/media/Lord Varys.87949a40.jpg";